import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth' // getToken from cookie
import {routesModule} from '@/router'

NProgress.configure({showSpinner: false})// NProgress Configuration

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

const whiteList = ['/login', '/authredirect']// no redirect whitelist
function saveObjArr(name, data) { //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));
}

let getRouter //用来获取后台拿到的路由

router.beforeEach((to, from, next) => {   //最重要的第一步就是检查token  第二步检查路由在不在本地
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token*/
    if (to.path === '/login') {
      // next('/')
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        let routesList = []
        // store.dispatch('selectUserBindRoleByUserId').then(res => {
        //   let jsonBodyData = res.jsonBody
        //   let codes = jsonBodyData.msgBody.codes
        //   console.log(codes)
        // })
        // alert(getRouter)
        // alert(JSON.stringify(getObjArr('router')))
        if (!getRouter) {//不加这个判断，路由会陷入死循环
          if (!getObjArr('router')) {
            if (store.getters.roletype == 2 || store.getters.roletype == 3) {
              let V3_0_OrgChildManage = [
                {
                  path: '',
                  component: 'Layout',
                  children: [
                    {
                      path: 'organizationMge',
                      component: '/organizationMge/index',
                      name: 'organizationMge',
                      meta: {
                        title: 'organizationMge',
                        icon: 'groups',
                        noCache: true,
                        chineseName: '代理商管理平台-组织管理'
                      },
                      setName: 'V3_0_OrganizationManage'
                    }
                  ]
                },
                {
                  path: '',
                  component: 'Layout',
                  children: [
                    {
                      path: 'superEquipmentMge',
                      component: '/superEquipmentMge/index',
                      name: 'superEquipmentMge',
                      meta: {
                        title: 'equipmentMge',
                        icon: 'devices',
                        noCache: true,
                        chineseName: '代理商管理平台-设备管理'
                      },
                      setName: 'V3_0_OrganizationManage'
                    }
                  ]
                },
                {
                  path: '',
                  component: 'Layout',
                  children: [
                    {
                      path: 'superMeetDoorMge',
                      component: '/meetings/superMeetDoorMge',
                      name: 'meetingDoorManager',
                      meta: {
                        title: 'meetingDoorManager',
                        icon: 'meeting',
                        noCache: true,
                        chineseName: '代理商管理平台-会议室门牌管理'
                      },
                      setName: 'V3_0_CardManageCenter_RepairLog'
                    }
                  ]
                }
              ]
              routesList = V3_0_OrgChildManage
              saveObjArr('router', routesList) //存储路由到localStorage
              store.dispatch('GenerateRoutes', {routesList}).then(() => {
                router.addRoutes(store.getters.addRouters)
              })
              next({to, replace: true})
            } else {
              store.dispatch('selectUserBindRoleByUserId').then(res => {
                let jsonBodyData = res.jsonBody
                let codes = jsonBodyData.msgBody.codes
                routesModule.forEach(function (v, i) {
                  /*forEach(function(value,index.array))
                    第一个参数是遍历的数组内容，
                    第二个参数是对应的数组索引，
                    第三个参数是数组本身*/
                  let newItemData = JSON.parse(JSON.stringify(v))

                  newItemData.routes.children = []
                  let isAdd = false
                  // if(store.getters.roletype == 2 || store.getters.roletype == 3){
                  //   if(v.name == "V3_0_OrgChildManage" || v.name == "V3_0_OrganizationManage"){
                  //
                  //   }
                  // }else {
                  if (v.name == "V3_0_DeviceManage" || v.name == "V3_0_UserManage" || v.name == "V3_0_OrganizationManage" || v.name == "V3_0_OrgChildManage" || v.name == "V3_0_CloudSpaceManage") {
                    if (v.name == "V3_0_OrganizationManage") {
                      if (store.getters.roletype == 1 || store.getters.roletype == 0) {
                        if (codes.indexOf(v.name) >= 0) {
                          isAdd = true
                        }
                      } else {
                        return false
                      }
                    } else if (v.name == "V3_0_OrgChildManage") {
                      if (store.getters.roletype == 1 || store.getters.roletype == 0) {
                        return false
                      } else {
                        if (codes.indexOf(v.name) >= 0) {
                          isAdd = true
                        }
                      }
                    } else {
                      let isJudgment = stringJudgmentName(codes, v.name)
                      if (isJudgment) {
                        isAdd = true
                      }
                    }
                  } else {

                    if (v.name == "V3_0_AuthorityMge" || v.name == "V3_0_IQManageCenter_MediaDeviceManage" || v.name == "V3_0_IQManageCenter_Setting") {
                      if (store.getters.roletype == 1) {
                        isAdd = true
                      } else {
                        isAdd = false
                      }
                    } else {
                      // return false
                      isAdd = true
                    }
                  }
                  // }
                  if ((v.routes.children.length > 0) && (isAdd)) {
                    let childrenData = v.routes.children
                    isAdd = recursiveChildren(childrenData, codes, newItemData.routes)
                  }
                  if (isAdd) {
                    routesList.push(newItemData.routes)
                  }
                })
                console.log('routesList', routesList)
                saveObjArr('router', routesList) //存储路由到localStorage
                store.dispatch('GenerateRoutes', {routesList}).then(() => {
                  router.addRoutes(store.getters.addRouters)
                })
                next({to, replace: true})

              })
            }

          } else {
            routesList = getObjArr('router')//拿到路由
            getRouter = getObjArr('router')//拿到路由
            let roleRouter = getObjArr('router')
            store.dispatch('GenerateRoutes', {routesList}).then(() => {
              router.addRoutes(store.getters.addRouters)
            })
            next({to, replace: true})
          }
          // store.dispatch('GenerateRoutes', {  routesList }).then(() => {
          //   router.addRoutes(store.getters.addRouters)
          // })
          // next({to, replace: true })
        } else {
          next()
        }


        // store.dispatch('GetUserInfo').then(res => { // 拉取user_info
        //   const roles = res.data.roles // note: roles must be a array! such as: ['editor','develop']
        //   store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
        //     router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
        //     next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        //   })
        // }).catch((err) => {
        //   store.dispatch('FedLogOut').then(() => {
        //     Message.error(err || 'Verification failed, please login again')
        //     next({ path: '/' })
        //   })
        // })
      } else {
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        if (hasPermission(store.getters.roles, to.meta.roles)) {
          next()//
        } else {
          next({path: '/401', replace: true, query: {noGoBack: true}})
        }
        // 可删 ↑
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      // next()
      window.location.href = "/console/login";
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

function stringJudgmentName(codes, vName) {
  let codesData = codes.length
  let result = false
  for (let i = 0; i < codesData; i++) {
    let itmeCodes = codes[i]
    if (itmeCodes.indexOf(vName) >= 0) {
      result = true
      break
    }
  }
  return result
  // codesData.forEach(function (item,index) {
  //   item.includes
  // })
}

function recursiveChildren(childrenData, codes, routes) {
  let result = false
  childrenData.forEach(function (item, index) {
    // let setNameType = stringJudgmentName (codes,item.setName)
    // if(setNameType){
    //   routes.children.push(item)
    //   result = true
    // }
    // if(codes.indexOf(item.setName) >= 0){
    //   routes.children.push(item)
    //   result = true
    // }
    if (item.setName == "V3_0_DeviceManage_RepairLog") {
      let setNameType = stringJudgmentName(codes, item.setName)
      if (setNameType) {
        routes.children.push(item)
        result = true
      }
    } else {
      routes.children.push(item)
      result = true
    }


    if (item.children != undefined) {
      if (item.children.length > 1) {
        result = recursiveChildren(item.children, codes, routes.routes)
      }
    }
  })
  return result
}

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js